var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "professional-picture-box" },
    [
      _c(
        "a",
        {
          attrs: { href: "/cleaner/" + _vm.professional.id, target: "_blank" }
        },
        [
          _c("img", {
            directives: [
              {
                name: "lazy",
                rawName: "v-lazy",
                value: _vm.professionalPicture(),
                expression: "professionalPicture()"
              }
            ],
            staticClass: "rounded-circle",
            class: _vm.imgClass,
            attrs: { width: _vm.imgSize }
          })
        ]
      ),
      _vm._v(" "),
      _vm.professional.is_excellent === 1
        ? _c(
            "router-link",
            { attrs: { to: "/excellent-provider", target: "_blank" } },
            [
              _c("img", {
                directives: [
                  {
                    name: "b-popover",
                    rawName: "v-b-popover.hover.top",
                    value: _vm.$i18n.t(
                      "message.professional.excellent_provider_detail",
                      { name: _vm.firstName(_vm.professional) }
                    ),
                    expression:
                      "$i18n.t('message.professional.excellent_provider_detail', {name: firstName(professional)})",
                    modifiers: { hover: true, top: true }
                  }
                ],
                staticClass: "badge-excellent",
                attrs: {
                  src: "/static/img/ic_badge_excellent.png",
                  width: _vm.badgeSize ? _vm.badgeSize : "30%",
                  title: _vm.$i18n.t(
                    "message.professional.excellent_provider_title"
                  )
                }
              })
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-be679f74", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be679f74","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/professional/components/ProfessionalPicture.vue
// module id = 1474
// module chunks = 0